import apiClient from '@utils/apiClient';
import {
    WeatherAreaListReq,
    WeatherAreaListRes,
    WeatherAreaAddReq,
    WeatherAreaInfo,
    WeatherAreaInfoRes,
    WeatherAreaUpdateReq,
} from '@/api/weather/area/type';
import { ApiResult } from '@/api/common/type';

export const api = {
    /**
     * 기상대지역코드목록
     * @param param
     */
    weatherAreaList: async (
        param: WeatherAreaListReq,
    ): Promise<WeatherAreaListRes> => {
        const response = await apiClient.post<WeatherAreaListRes>(
            '/api/v1/weather/area/list',
            param,
        );
        return response.data;
    },

    /**
     * 기상대지역 추가
     * @param param
     */
    weatherAreaAdd: async (param: WeatherAreaAddReq): Promise<ApiResult> => {
        const response = await apiClient.post<ApiResult>(
            '/api/v1/weather/area/add',
            param,
        );
        return response.data;
    },

    /**
     * 기상대지역 상세
     * @param areaIdx
     */
    weatherAreaInfo: async (areaIdx: number): Promise<WeatherAreaInfo> => {
        const response = await apiClient.get<WeatherAreaInfoRes>(
            `/api/v1/weather/area/${areaIdx}`,
        );
        return response.data.data;
    },

    /**
     * 기상대지역 수정
     * @param param
     */
    weatherAreaUpdate: async (
        param: WeatherAreaUpdateReq,
    ): Promise<ApiResult> => {
        const response = await apiClient.put<ApiResult>(
            '/api/v1/weather/area/update',
            param,
        );
        return response.data;
    },

    /**
     * 기상대지역 삭제
     * @param areaIdx
     */
    weatherAreaDelete: async (areaIdx: number): Promise<ApiResult> => {
        const response = await apiClient.delete<ApiResult>(
            `/api/v1/weather/area/delete/${areaIdx}`,
        );
        return response.data;
    },
};
